import { gql } from "@apollo/client";

const GETCHATCOUNTPERPAGEPERDAY = gql`
  query getChatCountPerPagePerDay(
    $agentId: [ID]
    $source: String!
    $timeFrame: String
  ) {
    getChatCountPerPagePerDay(
      agentId: $agentId
      source: $source
      timeFrame: $timeFrame
    ) {
      success
      error
      result
    }
  }
`;
export default GETCHATCOUNTPERPAGEPERDAY;
